// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ivr-questions-tab {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.iq-tab-header h2 {
  margin: 0 0 4px;
}

.iq-tab-desc {
  margin: 0;
  font-size: 13px;
  color: #666;
}

.iq-loading {
  font-size: 14px;
  color: #666;
}

.iq-empty {
  font-size: 14px;
  color: #666;
}

.iq-error {
  padding: 10px 14px;
  background: #fff0f0;
  border: 1px solid #fca5a5;
  border-radius: 6px;
  color: #b91c1c;
  font-size: 13px;
}

.iq-success {
  padding: 8px 14px;
  background: #f0fdf4;
  border: 1px solid #86efac;
  border-radius: 6px;
  color: #166534;
  font-size: 13px;
}

/* Questions list */
.iq-questions-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Question card */
.iq-question-card {
  background: var(--wellsky-white, #fff);
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 8px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.iq-question-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.iq-question-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.iq-identifier {
  font-family: monospace;
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  background: #f1f5f9;
  padding: 2px 8px;
  border-radius: 4px;
}

.iq-location {
  font-size: 12px;
  color: #64748b;
}

.iq-badge {
  font-size: 11px;
  padding: 2px 7px;
  border-radius: 10px;
  font-weight: 500;
}

.iq-badge.gather         { background: #dbeafe; color: #1d4ed8; }
.iq-badge.override-count { background: #fef3c7; color: #92400e; }
.iq-badge.inactive       { background: #fee2e2; color: #b91c1c; }

/* Text display (read mode) */
.iq-text-display {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.iq-lang-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: 13px;
}

.iq-lang-row.rejection .iq-lang-text {
  color: #92400e;
}

.iq-lang-row.rejection .iq-lang-label {
  color: #b45309;
}

.iq-lang-label {
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  min-width: 56px;
  flex-shrink: 0;
}

.iq-lang-text {
  color: #374151;
  line-height: 1.5;
}

.iq-empty {
  color: #94a3b8;
  font-style: italic;
}

/* Edit form */
.iq-edit-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 12px;
}

.iq-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.iq-field label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
}

.iq-field textarea,
.iq-field input[type="number"] {
  padding: 6px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  font-size: 13px;
  font-family: inherit;
  resize: vertical;
  background: #fff;
  color: #1e293b;
}

.iq-field textarea:focus,
.iq-field input[type="number"]:focus {
  outline: none;
  border-color: var(--wellsky-blue, #3b82f6);
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);
}

.field-hint {
  font-weight: 400;
  color: #94a3b8;
}

.iq-form-actions {
  display: flex;
  gap: 8px;
}

/* Overrides */
.iq-overrides-toggle {
  border-top: 1px solid #f1f5f9;
  padding-top: 8px;
}

.btn-toggle-overrides {
  background: none;
  border: none;
  padding: 0;
  font-size: 12px;
  color: #64748b;
  cursor: pointer;
  text-decoration: underline;
}

.btn-toggle-overrides:hover {
  color: var(--wellsky-blue, #3b82f6);
}

.iq-overrides-panel {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 10px 12px;
}

.iq-override-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 10px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
}

.iq-override-row.inactive {
  opacity: 0.55;
}

.iq-override-info {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 2px;
}

.iq-override-company {
  font-weight: 600;
  font-size: 13px;
  color: #1e293b;
}

.iq-override-actions {
  display: flex;
  gap: 6px;
  margin-top: 4px;
}

.iq-empty-overrides {
  font-size: 13px;
  color: #94a3b8;
  margin: 0;
}

.iq-override-form {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 10px;
  background: #fff;
  border: 1px solid #c7d2fe;
  border-radius: 6px;
}

/* Shared buttons */
.btn-edit-small {
  padding: 3px 10px;
  font-size: 12px;
  background: var(--wellsky-white, #fff);
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 4px;
  cursor: pointer;
  color: #374151;
}

.btn-edit-small:hover {
  border-color: var(--wellsky-blue, #3b82f6);
  color: var(--wellsky-blue, #3b82f6);
}

.btn-deactivate-small {
  padding: 3px 10px;
  font-size: 12px;
  background: var(--wellsky-white, #fff);
  border: 1px solid #fca5a5;
  border-radius: 4px;
  cursor: pointer;
  color: #b91c1c;
}

.btn-deactivate-small:hover {
  background: #fff0f0;
}

.btn-add-override {
  align-self: flex-start;
  padding: 5px 12px;
  font-size: 12px;
  background: var(--wellsky-white, #fff);
  border: 1px dashed #94a3b8;
  border-radius: 4px;
  cursor: pointer;
  color: #64748b;
}

.btn-add-override:hover {
  border-color: var(--wellsky-blue, #3b82f6);
  color: var(--wellsky-blue, #3b82f6);
}

.btn-save {
  padding: 5px 16px;
  background: var(--wellsky-indigo, #4f46e5);
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
}

.btn-save:hover:not(:disabled) {
  background: var(--wellsky-blue, #3b82f6);
}

.btn-save:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-cancel {
  padding: 5px 14px;
  background: var(--wellsky-white, #fff);
  border: 1px solid var(--color-border, #e5e7eb);
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  color: #374151;
}

.btn-cancel:hover {
  border-color: #94a3b8;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/tabs/IvrQuestionsTab.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,sCAAsC;EACtC,8CAA8C;EAC9C,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;AAChE,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;AAChE,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;;AAEhE,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,0CAA0C;EAC1C,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,cAAc;AACd;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,eAAe;EACf,sCAAsC;EACtC,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,sCAAsC;EACtC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,sCAAsC;EACtC,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".ivr-questions-tab {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.iq-tab-header h2 {\n  margin: 0 0 4px;\n}\n\n.iq-tab-desc {\n  margin: 0;\n  font-size: 13px;\n  color: #666;\n}\n\n.iq-loading {\n  font-size: 14px;\n  color: #666;\n}\n\n.iq-empty {\n  font-size: 14px;\n  color: #666;\n}\n\n.iq-error {\n  padding: 10px 14px;\n  background: #fff0f0;\n  border: 1px solid #fca5a5;\n  border-radius: 6px;\n  color: #b91c1c;\n  font-size: 13px;\n}\n\n.iq-success {\n  padding: 8px 14px;\n  background: #f0fdf4;\n  border: 1px solid #86efac;\n  border-radius: 6px;\n  color: #166534;\n  font-size: 13px;\n}\n\n/* Questions list */\n.iq-questions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Question card */\n.iq-question-card {\n  background: var(--wellsky-white, #fff);\n  border: 1px solid var(--color-border, #e5e7eb);\n  border-radius: 8px;\n  padding: 14px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.iq-question-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n\n.iq-question-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.iq-identifier {\n  font-family: monospace;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e293b;\n  background: #f1f5f9;\n  padding: 2px 8px;\n  border-radius: 4px;\n}\n\n.iq-location {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.iq-badge {\n  font-size: 11px;\n  padding: 2px 7px;\n  border-radius: 10px;\n  font-weight: 500;\n}\n\n.iq-badge.gather         { background: #dbeafe; color: #1d4ed8; }\n.iq-badge.override-count { background: #fef3c7; color: #92400e; }\n.iq-badge.inactive       { background: #fee2e2; color: #b91c1c; }\n\n/* Text display (read mode) */\n.iq-text-display {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.iq-lang-row {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  font-size: 13px;\n}\n\n.iq-lang-row.rejection .iq-lang-text {\n  color: #92400e;\n}\n\n.iq-lang-row.rejection .iq-lang-label {\n  color: #b45309;\n}\n\n.iq-lang-label {\n  font-size: 11px;\n  font-weight: 700;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  min-width: 56px;\n  flex-shrink: 0;\n}\n\n.iq-lang-text {\n  color: #374151;\n  line-height: 1.5;\n}\n\n.iq-empty {\n  color: #94a3b8;\n  font-style: italic;\n}\n\n/* Edit form */\n.iq-edit-form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  padding: 12px;\n}\n\n.iq-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.iq-field label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #475569;\n}\n\n.iq-field textarea,\n.iq-field input[type=\"number\"] {\n  padding: 6px 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 4px;\n  font-size: 13px;\n  font-family: inherit;\n  resize: vertical;\n  background: #fff;\n  color: #1e293b;\n}\n\n.iq-field textarea:focus,\n.iq-field input[type=\"number\"]:focus {\n  outline: none;\n  border-color: var(--wellsky-blue, #3b82f6);\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.15);\n}\n\n.field-hint {\n  font-weight: 400;\n  color: #94a3b8;\n}\n\n.iq-form-actions {\n  display: flex;\n  gap: 8px;\n}\n\n/* Overrides */\n.iq-overrides-toggle {\n  border-top: 1px solid #f1f5f9;\n  padding-top: 8px;\n}\n\n.btn-toggle-overrides {\n  background: none;\n  border: none;\n  padding: 0;\n  font-size: 12px;\n  color: #64748b;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.btn-toggle-overrides:hover {\n  color: var(--wellsky-blue, #3b82f6);\n}\n\n.iq-overrides-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  padding: 10px 12px;\n}\n\n.iq-override-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 8px 10px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n}\n\n.iq-override-row.inactive {\n  opacity: 0.55;\n}\n\n.iq-override-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 2px;\n}\n\n.iq-override-company {\n  font-weight: 600;\n  font-size: 13px;\n  color: #1e293b;\n}\n\n.iq-override-actions {\n  display: flex;\n  gap: 6px;\n  margin-top: 4px;\n}\n\n.iq-empty-overrides {\n  font-size: 13px;\n  color: #94a3b8;\n  margin: 0;\n}\n\n.iq-override-form {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 8px 10px;\n  background: #fff;\n  border: 1px solid #c7d2fe;\n  border-radius: 6px;\n}\n\n/* Shared buttons */\n.btn-edit-small {\n  padding: 3px 10px;\n  font-size: 12px;\n  background: var(--wellsky-white, #fff);\n  border: 1px solid var(--color-border, #e5e7eb);\n  border-radius: 4px;\n  cursor: pointer;\n  color: #374151;\n}\n\n.btn-edit-small:hover {\n  border-color: var(--wellsky-blue, #3b82f6);\n  color: var(--wellsky-blue, #3b82f6);\n}\n\n.btn-deactivate-small {\n  padding: 3px 10px;\n  font-size: 12px;\n  background: var(--wellsky-white, #fff);\n  border: 1px solid #fca5a5;\n  border-radius: 4px;\n  cursor: pointer;\n  color: #b91c1c;\n}\n\n.btn-deactivate-small:hover {\n  background: #fff0f0;\n}\n\n.btn-add-override {\n  align-self: flex-start;\n  padding: 5px 12px;\n  font-size: 12px;\n  background: var(--wellsky-white, #fff);\n  border: 1px dashed #94a3b8;\n  border-radius: 4px;\n  cursor: pointer;\n  color: #64748b;\n}\n\n.btn-add-override:hover {\n  border-color: var(--wellsky-blue, #3b82f6);\n  color: var(--wellsky-blue, #3b82f6);\n}\n\n.btn-save {\n  padding: 5px 16px;\n  background: var(--wellsky-indigo, #4f46e5);\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.btn-save:hover:not(:disabled) {\n  background: var(--wellsky-blue, #3b82f6);\n}\n\n.btn-save:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-cancel {\n  padding: 5px 14px;\n  background: var(--wellsky-white, #fff);\n  border: 1px solid var(--color-border, #e5e7eb);\n  border-radius: 4px;\n  font-size: 13px;\n  cursor: pointer;\n  color: #374151;\n}\n\n.btn-cancel:hover {\n  border-color: #94a3b8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
